import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';
import {
  CALLABLES,
  type DriversNominateInput,
  type DriversNominateResponse,
  type DriversListPeopleResponse,
  type DriversMyReceivedResponse,
  type DriversMyGivenResponse,
  type DriversMyCabinetResponse,
  type DriversMonthInput,
  type DriversSetWinnerInput,
  type DriversReleaseInput,
  type DriversAnnualExportInput,
  type DriversAdminListMonthsResponse,
  type DriversAdminGetMonthResponse,
  type DriversSetWinnerResponse,
  type DriversReleaseResponse,
  type DriversAnnualExportResponse,
  type DriversTeamOverviewResponse,
  type DriversOrgSummaryResponse,
  type DriversOrgSummaryInput,
} from '@daaily/shared';

export const callDriversListPeople = httpsCallable<void, DriversListPeopleResponse>(
  functions,
  CALLABLES.DRIVERS_LIST_PEOPLE,
);
export const callDriversNominate = httpsCallable<DriversNominateInput, DriversNominateResponse>(
  functions,
  CALLABLES.DRIVERS_NOMINATE,
);
export const callDriversMyReceived = httpsCallable<void, DriversMyReceivedResponse>(
  functions,
  CALLABLES.DRIVERS_MY_RECEIVED,
);
export const callDriversMyGiven = httpsCallable<void, DriversMyGivenResponse>(
  functions,
  CALLABLES.DRIVERS_MY_GIVEN,
);
export const callDriversMyCabinet = httpsCallable<void, DriversMyCabinetResponse>(
  functions,
  CALLABLES.DRIVERS_MY_CABINET,
);

// Admin / board
export const callDriversListMonths = httpsCallable<void, DriversAdminListMonthsResponse>(
  functions,
  CALLABLES.DRIVERS_ADMIN_LIST_MONTHS,
);
export const callDriversGetMonth = httpsCallable<DriversMonthInput, DriversAdminGetMonthResponse>(
  functions,
  CALLABLES.DRIVERS_ADMIN_GET_MONTH,
);
export const callDriversSetWinner = httpsCallable<DriversSetWinnerInput, DriversSetWinnerResponse>(
  functions,
  CALLABLES.DRIVERS_SET_WINNER,
);
export const callDriversRelease = httpsCallable<DriversReleaseInput, DriversReleaseResponse>(
  functions,
  CALLABLES.DRIVERS_RELEASE,
);
export const callDriversAnnualExport = httpsCallable<
  DriversAnnualExportInput,
  DriversAnnualExportResponse
>(functions, CALLABLES.DRIVERS_ANNUAL_EXPORT);
export const callDriversTeamOverview = httpsCallable<void, DriversTeamOverviewResponse>(
  functions,
  CALLABLES.DRIVERS_TEAM_OVERVIEW,
);
export const callDriversOrgSummary = httpsCallable<DriversOrgSummaryInput, DriversOrgSummaryResponse>(
  functions,
  CALLABLES.DRIVERS_ORG_SUMMARY,
);
